import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, MatIcon, MatIconButton],
  selector: 'iot-platform-ui-detail-panel',
  templateUrl: './detail-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-panel.component.scss']
})
export class DetailPanelComponent {
  title = input<string>();
  hasButton = input<boolean>(false);
  clickEvent = output<void>();

  onClick() {
    this.clickEvent.emit();
  }
}
